import Vue from "vue";
export default Vue.extend({
    name: 'HeadlineText',
    props: {
        content: {
            type: Object,
            default() {
                return [];
            }
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./src/pagebuilder-components/HeadlineText/HeadlineText.ts
// module id = null
// module chunks = 